const projectTSA = [
  {
    title: "Amazon with Next JS",
    category: "E-commerce app with Next JS and Stripe payments",
    image:
      "https://tanishq.technyteams.co.in/images/portfolio/Next amazon.jpeg",
    url: "https://amazon-by-tsa.vercel.app/",
    github: "https://github.com/TanishqSinghAnand/Amazon-by-TSA",
  },
  {
    title: " YPS Google",
    category: "Google clone built with React",
    image: "https://tanishq.technyteams.co.in/images/portfolio/YPS_Google.png",
    url: "https://clone-c29a7.web.app/",
    github: "https://github.com/TanishqSinghAnand/google-clone",
  },
  {
    title: "WhatsApp",
    category: "WhatsApp clone built with React",
    image: "https://tanishq.technyteams.co.in/images/portfolio/WhatsApp.jpeg",
    url: "https://whatsapp-clone-c7a05.web.app/",
    github: "https://github.com/TanishqSinghAnand/Whatsapp-Clone",
  },
  {
    title: "Metaverse - Web3 realtime chat app",
    category: "Build with NextJs,Moralis, TailwindCSS",
    image:
      "https://tanishq.technyteams.co.in/images/portfolio/Metaverse%20Chat%20App.png",
    url: "https://metaverse-gamma.vercel.app/",
    github: "https://github.com/TanishqSinghAnand/MetaVerse",
  },
  {
    title: "NFT Drop MarketPlace",
    category: "Build with NextJs, ThirdWeb, TailwindCSS",
    image: "https://tanishq.technyteams.co.in/images/portfolio/NFT-Drop.png",
    url: "https://nft-drop-techny-teams.vercel.app/",
    github: "https://github.com/TanishqSinghAnand/NFT-Drop",
  },
  {
    title: "NextJs Search Engine",
    category: "Google like app build with GoogleAPI, NextJS, TailwindCss",
    image:
      "https://tanishq.technyteams.co.in/images/portfolio/Next-Js-Google.png",
    url: "https://nextjs-google-by-tanishq.vercel.app/",
    github: "https://github.com/TanishqSinghAnand/next-google",
  },
  {
    title: "Covid-19 Tracker",
    category: "Covid-19 Tracker built with React",
    image:
      "https://tanishq.technyteams.co.in/images/portfolio/covid-tracker.jpeg",
    url: "https://covidtrackerbytanishq.netlify.app/",
    github: "https://github.com/TanishqSinghAnand/Covid-19-Tracker",
  },
  {
    title: "Discord",
    category: "Discord built with React",
    image: "https://tanishq.technyteams.co.in/images/portfolio/Discord.jpeg",
    url: "https://discordbytanishq.netlify.app/",
    github: "https://github.com/TanishqSinghAnand/My_Discord",
  },
  {
    title: "Techny Teams Responsive Website",
    category: "Build with HTML , CSS and JS",
    image:
      "https://tanishq.technyteams.co.in/images/portfolio/Techny Teams.jpeg",
    url: "https://technyteams.netlify.app/",
    github: "https://github.com/TanishqSinghAnand/Techny-Teams",
  },
  {
    title: "Netflix UI ",
    category: "Build with React (Still in development)",
    image: "https://tanishq.technyteams.co.in/images/portfolio/Netflix.png",
    url: "https://netflix-clone-by-tanishq.netlify.app/",
    github: "https://github.com/TanishqSinghAnand/Netflix",
  },
  {
    title: "Panchhi Dental Clinic Website",
    category: "Build with React (Still in development)",
    image:
      "https://tanishq.technyteams.co.in/images/portfolio/Panchhi_Dental_Clinic.jpeg",
    url: "https://panchhidentalclinic.netlify.app/",
    github: "",
  },
  {
    title: "Attendence app",
    category: "Attendence App built with react native",
    image:
      "https://tanishq.technyteams.co.in/images/portfolio/Attendence App.png",
    url: "https://attendence-app-hosted.web.app/",
    github: "https://github.com/TanishqSinghAnand/Attendence-app",
  },
  {
    title: "Calculator",
    category: "Calculator made with Javascript",
    image: "https://tanishq.technyteams.co.in/images/portfolio/Calculator.png",
    url: "https://tanishqsinghanand.github.io/Final-Calculator/",
    github: "https://github.com/TanishqSinghAnand/Final-Calculator",
  },
  {
    title: "Tic-Tac-Toe",
    category: "Tic-Tac-Toe made with Javascript (P5.js)",
    image: "https://tanishq.technyteams.co.in/images/portfolio/Tic-Tac-Toe.png",
    url: "https://tanishqsinghanand.github.io/TICTACTOE/",
    github: "https://github.com/TanishqSinghAnand/TICTACTOE",
  },
];

export default projectTSA;
